import React from "react";
import "./style.css";

const SplashScreen = () => {
  return (
    <div className="splash_screen">
      <div className="splash_screen_content">
        <img src={require("../../assets/images/app-button.png")} alt="Logo" />
        <h1>Salud Justicia</h1>
      </div>
    </div>
  );
};

export default SplashScreen;
